import { render, staticRenderFns } from "./TermsofUseModal.vue?vue&type=template&id=37593d00&scoped=true&"
import script from "./TermsofUseModal.vue?vue&type=script&lang=js&"
export * from "./TermsofUseModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsofUseModal.vue?vue&type=style&index=0&id=37593d00&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37593d00",
  null
  
)

export default component.exports